import { LokiAdvancedSearchController } from "./loki-advanced-search.controller";
import { IComponentOptions } from "angular";

angular
    .module("thor.loki.advanced-search.component", [])
    .component("lokiAdvancedSearch", <IComponentOptions>{
        controller: LokiAdvancedSearchController,
        bindings: {
            isOpen: "="
        },
        template: require("./advanced-search.html")
    });
